import React from 'react'
import {
    ContainerFluid,Container,HeadingText,CtaText,Button
} from './BeforeFooterComponent.style';
function BeforeFooterComponent() {
  return (
    <div>
        <ContainerFluid className=''>
            <Container>
                <div className='container-custom'>
                    
                    <div className='row'>
                        <div className='col s12 '>
                            <div className='mt-50' style={{
                                width:"43px",
                                height:"43px",
                                borderRadius:"100%",
                                background:" rgba(255, 255, 255, 0.11)"
                            }}></div>
                        </div>
                        <div className='col s12 m12 l6'>
                            <HeadingText>
                                <b>
                                Download the
                                Yalla app to 
                                start investing
                                </b>
                            </HeadingText>
                        </div>
                        <div className='col s12 m12 l6'>
                            <CtaText>
                                Available on
                            </CtaText>
                            <div className='row'>
                                <div className='col s12'>
                                <div style={{
                                    display:"flex",
                                    flexWrap:"wrap"
                                }}>
                                <a href='https://play.google.com/store/apps/details?id=com.yallavest.android'>
                                    <Button>
                                        <img src="https://res.cloudinary.com/yalla-ng/image/upload/v1657110914/re-brand/icons/logo-google-playstore.svg"
                                        width="40px"
                                        alt=""/>
                                        <div style={{width:"20px"}}></div>
                                        <div style={{
                                            marginTop:"15px"
                                        }}>
                                            <span className="left" style={{
                                            }}>GET IT ON</span>
                                            <span className="left" style={{
                                                fontSize:"14.9425px",
                                            }}><b>Play Store</b></span>
                                        </div>
                                    </Button>
                                    </a>
                                    <div style={{width:"20px"}}></div>
                                    <a href="https://apps.apple.com/us/app/yalla-ng-save-invest/id1617363028">
                                    <Button>
                                        <img src="https://res.cloudinary.com/yalla-ng/image/upload/v1657110911/re-brand/icons/Appstor%20icon.svg"
                                        width="30px"
                                        alt=""/>
                                        <div style={{width:"20px"}}></div>
                                        <div style={{
                                            marginTop:"15px"
                                        }}>
                                            <span className="left" style={{
                                            }}>GET IT ON</span>
                                            <span className="left" style={{
                                                fontSize:"14.9425px",
                                            }}><b>App Store</b></span>
                                        </div>
                                    </Button>
                                    </a>
                                </div>

                            </div>
                            
                        </div>
                        </div>
                  </div>     
                </div>
            </Container>
        </ContainerFluid>
    </div>
  )
}

export default BeforeFooterComponent